import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UIService } from '@services';
import { DevicesStore, RichDevice, InstallationFeaturesStore } from '@store';
import {
  DeviceStatusType,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsNumberValueProperty,
  PhotovoltaicStatusProperties,
} from '@vi-iot/client';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';

@Component({
  selector: 'app-solarlog',
  templateUrl: './solarlog.component.html',
  styleUrls: ['./solarlog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolarLogComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  protected device$: Observable<RichDevice>;

  readonly FeaturesDetailsOverlayTypeEnum = FeaturesDetailsOverlayTypeEnum;
  readonly DeviceStatusType = DeviceStatusType;
  readonly featurePropertyKey = FeaturePropertyKey;

  solarLogState$: Observable<Feature<PhotovoltaicStatusProperties, never>>;
  currentProduction$: Observable<Feature<IsNumberValueProperty, never>>;

  constructor(
    private devicesStore: DevicesStore,
    private installationFeaturesStore: InstallationFeaturesStore,
    private uiService: UIService
  ) {}

  ngOnInit(): void {
    this.device$ = this.devicesStore.selectedDevice$;

    this.devicesStore.getSolarLogInverter$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((inverter) => {
        this.solarLogState$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
          FeatureNames.photovoltaicStatus,
          inverter.id
        );
        this.currentProduction$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
          FeatureNames.productionCurrent,
          inverter.id
        );
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  openSettingsOverlay(): void {
    this.uiService.openActiveOverlay(FeaturesDetailsOverlayTypeEnum.SolarLog);
  }
}
